import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IComponentProps } from './index';

export const generate = (
  props?: Partial<IComponentSchema<IComponentProps>>
): IComponentSchema<IComponentProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.OBJECT,
    name: props?.name || id,
    title: props?.title || 'ePI',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.EpiBuilder,
    'x-component-props': {
      canAddProduct: true,
      canRemoveProduct: true,
      canManageDocuments: true,
      canRenameDocuments: true,
      canAddCustomSections: true,
      canExport: true,
      canImport: false,
      defaultLanguage: 'sr',
      readOnly: false,
      ...(props?.['x-component-props'] ?? {}),
    },
    'x-component-props-config': {},
  };
};
